export const SET_RECIPE_LIMIT_REACHED = "SET_RECIPE_LIMIT_REACHED"
export const SET_INACTIVE = "SET_INACTIVE"
export const SET_ALLOW_TO_PROTECTED_ROUTES = "SET_ALLOW_TO_PROTECTED_ROUTES"
